module.exports = __webpack_public_path__ + "images/edm_social_facebook_x28.png";


//////////////////
// WEBPACK FOOTER
// ./vively/images/email/edm_social_facebook_x28.png
// module id = 867
// module chunks = 3